// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"320":"ucare-panel-chunk","512":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"320":"7d54fd05","376":"49d20605","512":"9238d50a","592":"90a3bc52"}[chunkId] + ".chunk.js";
};